<template>
    <div :class="containerClass" @click="onWrapperClick">
        <AppTopBar @menu-toggle="onMenuToggle"/>
        <div class="layout-sidebar" @click="onSidebarClick">
            <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
        </div>

        <div class="layout-main-container">
            <div class="layout-main">
                <div class="text-center" v-if="!checkProdUrl">
                    <p style="font-weight: bold; color: red;">Тестове середовище для розробки, продуктове за <a href="https://services.vector-vs.com/">посиланням</a></p>
                    <br>
                </div>
                <slot/>
            </div>
            <AppFooter/>
        </div>

        <transition name="layout-mask">
            <div class="layout-mask p-component-overlay" v-if="mobileMenuActive"></div>
        </transition>
        <Toast/>
    </div>
</template>

<script>
import AppTopBar from '../Components/AppTopbar.vue';
import AppMenu from '../Components/AppMenu.vue';
import AppFooter from '../Components/AppFooter.vue';
import Toast from 'primevue/toast';

export default {
    data() {
        return {
            layoutMode: 'static',
            layoutColorMode: 'light',
            staticMenuInactive: true,
            overlayMenuActive: false,
            mobileMenuActive: false,
            menu: [
                {
                    label: 'Навігація',
                    items: [
                        // {label: 'Главная', icon: 'pi pi-fw pi-home', to: this.route('dashboard'), prefix: 'dashboard', allowedRoles: []},
                        {label: 'Користувачі', icon: 'pi pi-fw pi-user', to: this.route('users.index'),allowedRoles: ['admin']},
                        {label: 'Профіль', icon: 'pi pi-fw pi-user-edit', to: this.route('user.profile'),allowedRoles: []},
                        {label: 'Адміністрування усіх сервісів', icon: 'pi pi-fw pi-table',allowedRoles: ['admin'], items: [
                            {label: 'Сервіси. Головна сторінка', icon: 'pi pi-fw pi-table', to: this.route('services.list'),allowedRoles: ['admin']},
                            {label: 'Опис роботи сервісів', icon: 'pi pi-fw pi-table', to: this.route('api.service_description.index'),allowedRoles: ['admin']},
                            {label: 'Адміністування товарів', icon: 'pi pi-fw pi-table', to: this.route('api.configurator-products'),allowedRoles: ['admin']},
                            {label: 'Експорт в Excel', icon: 'pi pi-fw pi-table', to: this.route('api.configurator-products.excel'),allowedRoles: ['admin']},
                            {label: 'Документація API', icon: 'pi pi-fw pi-table', url: this.route('doc'),allowedRoles: ['admin']},
                        ]},
                        {label: 'Прайс-лист', icon: 'pi pi-fw pi-table', url: this.route('price-list-internal'), target: "_blank", allowedRoles: ['sale']},
                        {label: 'Прайс-лист', icon: 'pi pi-fw pi-table', url: this.route('price-list'), target: "_blank", allowedRoles: ['client']},
                        {label: 'Сервіс Прайс-лист', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin', 'pm'], items: [
                            // {label: 'Прайс-лист клієнтська частина', icon: 'pi pi-fw pi-table', url: this.route('price-list'), target: "_blank", allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Прайс-лист внутрішній', icon: 'pi pi-fw pi-table', url: this.route('price-list-internal'), target: "_blank", allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Прайс-лист зовнішній', icon: 'pi pi-fw pi-table', url: this.route('price-list'), target: "_blank", allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Прайс-лист нова структура', icon: 'pi pi-fw pi-table', url: this.route('price-list-categories'), target: "_blank", allowedRoles: ['admin', 'service_admin', 'pm']},
                            // {label: 'Каталог товарів', icon: 'pi pi-fw pi-table', to: this.route('upload-catalog-products'), allowedRoles: ['admin', 'service_admin']},
                            // {label: 'Завантаження в бд', icon: 'pi pi-fw pi-table', to: this.route('upload-catalog'), allowedRoles: ['admin', 'service_admin']},
                            {label: 'Імпорт в БД', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                                {label: 'Характеристики', icon: 'pi pi-fw pi-table', to: this.route('upload-catalog-characteristics'), allowedRoles: ['admin']},
                                {label: 'Оновлення товарів', icon: 'pi pi-fw pi-table', to: this.route('upload-catalog-descriptions'), allowedRoles: ['admin']},
                                {label: 'Фото', icon: 'pi pi-fw pi-table', to: this.route('upload-catalog-images'), allowedRoles: ['admin']},
                            ]},
                            {label: 'Адмін SKU', icon: 'pi pi-fw pi-table', allowedRoles: ['admin'], items: [
                                {label: 'Характеристики', icon: 'pi pi-fw pi-table', to: this.route('api.vector.characteristics'), allowedRoles: ['admin']},
                                {label: 'Типи документів', icon: 'pi pi-fw pi-table', to: this.route('api.vector.documenttypes'), allowedRoles: ['admin']},
                                {label: 'Категорії товарів', icon: 'pi pi-fw pi-table', to: this.route('api.vector.producttypes'), allowedRoles: ['admin']},
                                {label: 'Посилання на завантаження Excel', icon: 'pi pi-fw pi-table', to: this.route('api.vector.pricelist.urls'), allowedRoles: ['admin']},
                                {label: 'Типи аксесуарів', icon: 'pi pi-fw pi-table', to: this.route('api.vector.acessories.types'), allowedRoles: ['admin']},
                            ]},
                            {label: 'Картка SKU', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin', 'pm'], items: [
                                {label: 'Картка SKU', icon: 'pi pi-fw pi-table', to: this.route('api.vector.upload-sku-files'), allowedRoles: ['admin', 'service_admin', 'pm']},
                                {label: 'Група SKU', icon: 'pi pi-fw pi-table', to: this.route('api.vector.upload-sku-groups-files'), allowedRoles: ['admin', 'service_admin', 'pm']},
                                // {label: 'Документи для напрямку/групи', icon: 'pi pi-fw pi-table', to: this.route('api.vector.upload-catalog-sku-files'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            ]},
                            {label: 'Експорт в Excel', icon: 'pi pi-fw pi-table', to: this.route('api.vector.export-catalog-sku-files'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Дублі товарів', icon: 'pi pi-fw pi-table', to: this.route('api.vector.products_duplicates'), allowedRoles: ['admin', 'service_admin']},
                            {label: 'Список товарів', icon: 'pi pi-fw pi-table', to: this.route('api.vector.products_list'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Аналітика', icon: 'pi pi-fw pi-table', to: this.route('catalog-analitics'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Аналітика додаткова', icon: 'pi pi-fw pi-table', to: this.route('catalog-brand-analytics'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            {label: 'Історія змін', icon: 'pi pi-fw pi-table', to: this.route('product_history'),allowedRoles: ['admin']},
                            {label: 'Викачати файли товарів', icon: 'pi pi-fw pi-table', url: this.route('export-product-files'),allowedRoles: ['admin']},
                            {label: 'Експорт недоробок', icon: 'pi pi-fw pi-table', url: this.route('export-defects'),allowedRoles: ['admin']},
                            {label: 'Налаштування', icon: 'pi pi-fw pi-table', to: this.route('price_list_settings'), allowedRoles: ['admin', 'service_admin', 'pm']},
                            // {label: 'Google Token', icon: 'pi pi-fw pi-table', to: this.route('google-api-auth'), allowedRoles: ['admin', 'service_admin', 'pm']},
                        ]},
                        {label: 'Рішення', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Бібліотека типів Клієнтів', icon: 'pi pi-fw pi-table', to: this.route('api.decision.client_type_lib'), allowedRoles: ['admin']},
                            {label: 'Бібліотека рішень', icon: 'pi pi-fw pi-table', to: this.route('api.decision.decision_lib'), allowedRoles: ['admin', 'service_admin']},
                        ]},
                        {label: 'Підбір аналогів', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Ключові характеристики', icon: 'pi pi-fw pi-table', to: this.route('api.analogs.characteristics'), allowedRoles: ['admin', 'service_admin']},
                            {label: 'Аналітика', icon: 'pi pi-fw pi-table', to: this.route('api.analogs.analytics'), allowedRoles: ['admin']},
                            {label: 'Налаштування', icon: 'pi pi-fw pi-table', to: this.route('api.analogs.settings'), allowedRoles: ['admin']},
                        ]},
                        {label: 'Трекінг', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin', 'pm'], items: [
                            {label: 'Терміни постачання', icon: 'pi pi-fw pi-table', to: this.route('api.products.delivery_times'), allowedRoles: ['admin', 'service_admin', 'pm']},
                        ]},
                        {label: 'Реєстр КП', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Реєстр КП', icon: 'pi pi-fw pi-table', to: this.route('commercial-offers'),allowedRoles: []},
                            {label: 'Налаштування Email', icon: 'pi pi-fw pi-table', to: this.route('commercial-offers-emails'),allowedRoles: []},
                        ]},
                        {label: 'Сервіс Крос-референс', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin', 'osp', 'manager'], items: [
                            {label: 'Сервіс Крос-референс', icon: 'pi pi-fw pi-table', to: this.route('cross-reference'),allowedRoles: []},
                            {label: 'Завантаження БД', icon: 'pi pi-fw pi-table', to: this.route('upload-cross'),allowedRoles: ['admin', 'service_admin']},
                        ]},
                        {label: 'Сервіс КРМ', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Сервіс КРМ', icon: 'pi pi-fw pi-table', to: this.route('krm'),allowedRoles: []},
                            {label: 'Завантаження БД', icon: 'pi pi-fw pi-table', to: this.route('upload-krm'),allowedRoles: []},
                        ]},
                        {label: 'Сервіс Опитувальні листи', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Замовлення трансформаторів', icon: 'pi pi-fw pi-table', to: this.route('form.list'),allowedRoles: []},
                            {label: 'Замовлення шинопроводів', icon: 'pi pi-fw pi-table', to: this.route('busbar.list'),allowedRoles: []},
                            {label: 'Документи з шинопроводів', icon: 'pi pi-fw pi-table', to: this.route('busbar.docs'),allowedRoles: []},
                            {label: 'Налаштування опитувальних листів', icon: 'pi pi-fw pi-table', to: this.route('api.settings.index'),allowedRoles: []},
                        ]},
                        {label: 'Сервіс АВР', icon: 'pi pi-fw pi-table', to: this.route('api.avr_service.index'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс я5000', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Сервіс я5000', icon: 'pi pi-fw pi-table', to: this.route('api.ya5000_service.index'),allowedRoles: []},
                            {label: 'Схеми я5000', icon: 'pi pi-fw pi-table', to: this.route('api.ya5000_docs.index'),allowedRoles: []},
                        ]},
                        {label: 'Сервіс ЩО-90', icon: 'pi pi-fw pi-table', allowedRoles: ['admin', 'service_admin'], items: [
                            {label: 'Завантаження БД', icon: 'pi pi-fw pi-table', to: this.route('upload.sho90'),allowedRoles: []},
                            {label: 'Фото', icon: 'pi pi-fw pi-table', to: this.route('upload_photo.sho90'),allowedRoles: []},
                        ]},
                        {label: 'Сервіс ЩО-125', icon: 'pi pi-fw pi-table', to: this.route('upload.sho125'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс Плавні пуски', icon: 'pi pi-fw pi-table', to: this.route('upload.plavni-spusky'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс Клемні ряди', icon: 'pi pi-fw pi-table', to: this.route('upload.klemnyi-riad'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс "Оцінка терміну окупності ПКРП"', icon: 'pi pi-fw pi-table', to: this.route('upload.calculator'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс "Підбір жорсткої шини"', icon: 'pi pi-fw pi-table', to: this.route('upload.kalkulyator_pidboru_zhorstkoyi_shini'),allowedRoles: ['admin', 'service_admin']},
                        {label: 'Сервіс "Підбір гнучкої шини"', icon: 'pi pi-fw pi-table', to: this.route('upload.kalkulyator_pidboru_gnuchkoyi_shini'),allowedRoles: ['admin', 'service_admin']},

                        {label: 'Налаштування доступів', icon: 'pi pi-fw pi-table', to: this.route('security'),allowedRoles: ['admin']},
                        {label: 'Дамп БД', icon: 'pi pi-fw pi-table', to: this.route('db-dumps'),allowedRoles: ['admin']},
                        {label: 'Лог системи', icon: 'pi pi-fw pi-table', to: this.route('log'),allowedRoles: ['admin']},

                        // {label: 'Загрузка БД', icon: 'pi pi-fw pi-upload', to: this.route('upload'),allowedRoles: ['admin']},
                    
                        {
                            label: 'Вийти', icon: 'pi pi-fw pi-sign-out', command: () => {
                                this.$inertia.post(this.route('logout'))
                            },
                        }]
                },
            ]
        }
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        }
    },
    methods: {
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle(isClose = false) {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                } else if (this.layoutMode === 'static') {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            } else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutChange(layoutMode) {
            this.layoutMode = layoutMode;
        },
        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth >= 992;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static')
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
            }

            return true;
        }
    },
    computed: {
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static',
                'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$primevue.config.inputStyle === 'filled',
                'p-ripple-disabled': this.$primevue.config.ripple === false,
            }];
        },
        logo() {
            return (this.layoutColorMode === 'dark') ? "images/logo-white.svg" : "images/logo.svg";
        },
        checkProdUrl() {
            return window.location.hostname === 'services.vector-vs.com'
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppMenu': AppMenu,
        'AppFooter': AppFooter,
        Toast,
    }
}
</script>

<style>
.customTable table td {
    padding: 7px 1rem!important;
}
.productSkuTable table td {
    padding: 0px 1rem!important;
}
.productTabTable table td {
    padding: 0.3rem 1rem!important;
}
.productTabTable tbody tr:hover, .productSkuTable tbody tr:hover {
    background-color: #F0F8FF;
}
.customTable button.p-column-filter-menu-button {
    display: none!important;
}
.customTable button.p-column-filter-clear-button {
    visibility: visible!important;
}
.customTable thead .select-all-selected .p-checkbox .p-checkbox-box {
    border-color: #2196F3;
    background: #2196F3;
}
.customTable thead .select-all-selected .p-checkbox-icon:before {
    font-family: 'primeicons';
    --webkit-backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\e909";
}
</style>
